import { useState } from 'react'
import { Button, Check, ShareLink, useResponsiveClientValue } from 'reshaped'
import styles from '../Splash/Splash.module.css'

interface CopyToClipboardButtonProps {
  value: string
}

export function CopyToClipboardButton({ value }: CopyToClipboardButtonProps) {
  const [copied, setCopied] = useState(false)
  const buttonText = useResponsiveClientValue({ s: 'Copy', m: 'Copy link' })

  const handleCopy = () => {
    navigator.clipboard.writeText(value)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <Button
      color="neutral"
      icon={copied ? Check : ShareLink}
      onClick={handleCopy}
      fullWidth
      size="large"
      className={styles.metallicButton}
      attributes={{
        style: {
          boxShadow: 'none',
        },
      }}
    >
      {!copied ? buttonText : 'Copied!'}
    </Button>
  )
}
